export const CHINESE_KEYBOARD_NAME ={
  PINYIN:'PINYIN',
  ZHUYIN:'ZHUYIN',
  CANGJIE:'CANGJIE'
};